import React, { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./types";
import CoinDozerUtils from "./utils";
import "./coin-dozer.scss";

export const CoinDozerRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const orderedPayout = CoinDozerUtils.GetSymbols();
  return (
    <>
      <h5 className="card-title">Overview</h5>
      <p className="card-text">
        Coin Pusher is an arcade-style game where players drop coins onto a
        moving platform.
      </p>
      <p className="card-text">
        The coins are pushed forward and can fall off the front Payout Sink,
        winning prizes.
      </p>
      <p className="card-text">
        Alternatively, they might fall off the Side Sinks, resulting in the loss
        of the coin or prize.
      </p>
      <br />
      <h5 className="card-title">Rules</h5>
      <p className="card-text">
        1) Player chooses chips to place a bet. Each bet amount corresponds to
        its own game board.
      </p>
      <p className="card-text">
        2) Select the designated area to drop coins. 1 coin equals 1 wager.
      </p>
      <p className="card-text">
        3) The coin is dropped, and the moving platform pushes it onto the
        board.
      </p>
      <p className="card-text">
        4) Coins fall off the front edge, potentially winning payouts/prizes and
        charging the bonus meter at the top of the board.
      </p>
      <p className="card-text">
        5) When the bonus bar is full, a random bonus is earned, and the meter
        empties.
      </p>
      <p className="card-text">
        6) Player continues to place bets and earn payouts, prizes and bonuses.
      </p>
      <br />
      <h5 className="card-title">Payout</h5>
      <div className="card-text">
        <div className="row">
          {orderedPayout.map(([symbol, payout], i) => (
            <div key={symbol} className="col-6 col-md-3 pb-3">
              <div className="d-flex justify-content-center">
                {CoinDozerUtils.convertSymbol(+symbol, ["big"])}
              </div>
              <div className="text-center">{payout.join(" ~ ")} </div>
            </div>
          ))}
        </div>
      </div>
      <br />
      <h5 className="card-title">Special Bonus Feature</h5>
      <p className="card-text">
        Each coin played will add a random amount towards the bonus meter.
      </p>
      <p className="card-text">
        Once the Bonus Meter is full, the Special Slots will spin and reward you
        with a random Bonus effect.
      </p>
      <div className="d-flex">
        <img className="bonus" alt="Bonus" src="/cd/bonus.png" />
      </div>
      <br />
      <div className="d-flex align-items-center">
        <h6 className="card-title pe-3 m-0">Side Walls</h6>
        <img className="symbol big" alt="Side Walls" src="/cd/501.png" />
      </div>
      <p className="card-text">
        Walls rise up from both the Side Sinks, preventing coins and Prizes from
        falling in them for 15 seconds.
      </p>
      <div className="d-flex align-items-center">
        <h6 className="card-title pe-3 m-0">Lucky Wheel Spin</h6>
        <img className="symbol big" alt="Lucky Wheel Spin" src="/cd/502.png" />
      </div>
      <p className="card-text">
        Spins a wheel that stops on how long FREE coins and Prizes will rain
        down on the play area.
      </p>
      <div className="d-flex align-items-center">
        <h6 className="card-title pe-3 m-0">Coin Spray</h6>
        <img className="symbol big" alt="Coin Spray" src="/cd/505.png" />
      </div>
      <p className="card-text">
        A piggybank appears over the Payout Sink and breaks open, instantly
        spraying a random amount of coins into it.
      </p>
      <div className="d-flex align-items-center">
        <h6 className="card-title pe-3 m-0">Mighty Push</h6>
        <img className="symbol big" alt="Mighty Push" src="/cd/503.png" />
      </div>
      <p className="card-text">
        The Pusher over-extends nearly all the way to the Payout Sink, pushing
        all coins and Prizes along the way.
      </p>
      <div className="d-flex align-items-center">
        <h6 className="card-title pe-3 m-0">Full of Luck</h6>
        <img className="symbol big" alt="Full of Luck" src="/cd/506.png" />
      </div>
      <p className="card-text">
        Test your luck by choosing 1 of 3 boxes which will instantly give a
        large bonus payout, each box has a different amount.
      </p>
      <br />
      <h5 className="card-title">Auto Bet</h5>
      <p className="card-text">
        Choose between a preset number of rounds and press 'Start' to begin
        dropping coins.
      </p>
      <p className="card-text">
        Auto mode will be cancelled when the player leaves the game window/tab
        or app.
      </p>
      <div className="d-flex">
        <img className="autobet" alt="Auto Bet" src="/cd/auto_bet.png" />
      </div>
    </>
  );
};
